// components/shared/Loading.jsx
export function Loading({ message = "Cargando...", primaryColor = "#ea580c" }) {
  return (
    <div className="text-center py-12" aria-busy="true" aria-live="polite">
      <div
        className="inline-block animate-spin rounded-full h-10 w-10 border-4 border-t-transparent mb-4"
        style={{ borderColor: `${primaryColor}40`, borderTopColor: "transparent" }}
      />
      <p className="text-white font-semibold">{message}</p>
      <p className="text-slate-400 text-sm mt-1">Por favor, esperá un momento</p>
    </div>
  );
}
